import axios from 'axios';

/**
 * Extract a human-readable error message from an API error.
 *
 * The backend returns errors in the format:
 *   { success: false, error: { code: "...", message: "..." } }
 *
 * Axios wraps HTTP errors so that `error.message` is just
 * "Request failed with status code 400", which is useless to the user.
 * This function digs into `error.response.data` to find the real message.
 */
export function extractApiError(error: unknown, fallback = 'An unexpected error occurred'): string {
  if (axios.isAxiosError(error)) {
    // Try to get the backend's error message from the standard format
    const data = error.response?.data;
    const backendMessage =
      data?.error?.message ||
      data?.message ||
      (typeof data?.error === 'string' ? data.error : undefined);
    if (typeof backendMessage === 'string' && backendMessage.length > 0) {
      return backendMessage;
    }
    // Fall back to HTTP status text
    if (error.response?.statusText) {
      return error.response.statusText;
    }
  }
  if (error instanceof Error) {
    return error.message;
  }
  return fallback;
}
